import { useEffect, useMemo, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { PDPReactQueryKeys } from '../types'

interface Props {
    slug: string
}

export default function usePDPInitialLoading({ slug }: Props) {
    const [isLoading, setIsLoading] = useState(true)
    const [shouldSendRequest, setShouldSendRequest] = useState(true)

    const queryClient = useQueryClient()
    const queryKey = useMemo(() => [PDPReactQueryKeys.ProductData, { slug }], [slug])

    useEffect(() => {
        const init = async () => {
            if (shouldSendRequest) {
                await queryClient.refetchQueries({ queryKey })

                setShouldSendRequest(false)

                setIsLoading(false)
            }
        }

        init()
    }, [queryClient, queryKey, shouldSendRequest])

    return isLoading
}
